/* loaded by smart-asset */
export default require("./close~bbahVpKh.png")